import Link from 'next/link';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { UNAGI_GAMES_LINK } from '@web/features/const';
import { UnaIcon } from '@web/features/hub-rework/brand-icons';
import { GenericHubTile } from '@web/features/hub-rework/GenericHubTile';
import { useDesignsTokenTheme } from '@web/ui/theme/ThemeProvider';

import LottieAnimation from '../LottieAnimation';

import UnaTokenDarkLottie from './una-dark.json';
import UnaTokenLightLottie from './una-light.json';

const LottieContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 11.25rem;
  overflow: hidden;

  > * {
    width: 100%;
    max-width: 13rem;
    max-height: 100%;
  }
`;

// Same layout tuning as HanaAiAgentTile: clear the absolute title chip and
// tighten the Content block so the illustration breathes vertically.
const TunedHubTile = styled(GenericHubTile)`
  > div:nth-of-type(2) {
    margin-top: 3.5rem;
  }
  > div:nth-of-type(3) {
    padding-top: 0.5rem;
    gap: 1.25rem;
  }
`;

export const UnaTokenTile = () => {
  const t = useTranslations();
  const { isDarkMode } = useDesignsTokenTheme();
  return (
    <Link href={UNAGI_GAMES_LINK} target="_blank">
      <TunedHubTile
        variant="top"
        title={t('UNA_TOKEN_HUB_TILE')}
        subtitle={t('UNA_TOKEN_HUB_TILE_SUBTITLE')}
        description={t('UNA_TOKEN_HUB_TILE_DESCRIPTION')}
        linkText={t('UNA_TOKEN_HUB_TILE_LINK_TEXT')}
        href={UNAGI_GAMES_LINK}
        illustration={
          <LottieContainer>
            <LottieAnimation
              animationData={
                isDarkMode ? UnaTokenDarkLottie : UnaTokenLightLottie
              }
            />
          </LottieContainer>
        }
        badge={<UnaIcon size="3000" />}
      />
    </Link>
  );
};
